import * as ACTION_TYPES from '../actions/action_types'

export interface AuthStateType {
  is_auth: boolean
  callback: string
  error: boolean
}
export const initialState = {
  is_auth: true,
  callback: '/login',
  error: false,
}

const AuthReducer = (state: AuthStateType, action: A) => {
  switch (action.type) {
    case ACTION_TYPES.CHECK_AUTH:
    case ACTION_TYPES.IS_ERROR:
      console.log(action)
      return {
        ...state,
        ...action,
      }
    default:
      return {
        ...state,
      }
  }
}
export default AuthReducer
